<template>
  <div>
    <div :class="{'d-flex flex-wrap': flex}">
      <div
        v-for="(item, index) in items"
        v-bind:key="index"
        :class="{'mr-2': flex}"
        v-bind:style="{ width: flexWidth, maxWidth: flexWidth }"
      >
        <div class="input-group mb-1" :class="[sizeVal]">
          <div class="input-group-prepend" v-if="showIndex">
            <span class="input-group-text">
              {{index+1}}
              <span v-if="m">/{{m}}</span>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="items[index][0]"
            :readonly="disabled"
            :placeholder="$t(placeholderRegex)"
          >
          <input
            type="text"
            class="form-control"
            v-model="items[index][1]"
            :readonly="disabled"
            :placeholder="$t(placeholderValue)"
          >
          <div class="input-group-append" v-if="!disabled || !required">
            <span class="input-group-text pt" @click="deleteItem(index)" :title="deleteTooltip">x</span>
          </div>
        </div>
      </div>
    </div>
    <b-button
      type="button"
      variant="brand"
      class="btn-sm mt-1"
      @click="addItem()"
      v-if="!disabled || !required"
    >{{addLabel}}</b-button>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    addLabel: {
      type: String,
      default: () => "Add New Item"
    },
    deleteTooltip: {
      type: String,
      default: () => "Delete Item"
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showIndex: {
      type: Boolean,
      default: () => false
    },
    m: {
      type: String,
      default: () => ""
    },
    required: {
      type: Boolean,
      default: () => false
    },
    placeholderRegex: {
      type: String,
      default: () => ""
    },
    placeholderValue: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: ""
    },
    flex: {
      type: Boolean,
      default: false
    },
    flexWidth: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    }
  },
  methods: {
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem(index) {
      this.items.push(["", ""]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
